<template>
  <div class="overflow-x-auto">
    <table class="RunnerUpsTable StylizedTable">
      <thead>
        <tr>
          <td colspan="2">
            Участник
          </td>
          <td>
            Предположение
          </td>
          <td>
            Разлика
          </td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(person, index) in data"
          :key="person.id"
        >
          <td class="w-px">{{ index + 1 }}</td>
          <td>
            <div class="text-2xl flex items-center">
              <round-avatar
                :src="person.avatar.thumb"
                size="2xs"
                class="mr-2 flex-no-shrink"
              />
              {{ person.name }}
            </div>
            <div class="text-left text-orange opacity-50 mt-2">#{{ person.ticket_number }}</div>
          </td>
          <td class="font-segmented text-5xl w-px whitespace-no-wrap">{{ person.mileage | mileage }}</td>
          <td class="font-segmented text-5xl text-red w-px whitespace-no-wrap">{{ person.mileage | difference(mileage) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/**
 * @module RunnerUpsTable
 */
export default {
  name: 'RunnerUpsTable',
  props: {
    data: {
      type: Array,
      required: true
    },
    mileage: {
      type: [Number, String],
      default: 0
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
